import React, { useState, useRef } from 'react';
import axios from 'axios';
import { useAdmin } from '../../contexts/AdminContext';
import { Upload, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ImageUpload = ({ value, onChange, label = 'Image', testId = 'image' }) => {
  const { getAuthHeaders } = useAdmin();
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');
  const inputRef = useRef(null);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setError('');
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append('file', file);
      const res = await axios.post(`${API}/admin/upload`, fd, {
        headers: getAuthHeaders().headers,
      });
      const fullUrl = `${process.env.REACT_APP_BACKEND_URL}${res.data.url}`;
      onChange(fullUrl);
    } catch (err) {
      setError(err.response?.data?.detail || 'Upload failed. Try again.');
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = '';
    }
  };

  return (
    <div>
      <label className="body-small text-white mb-1 block">{label}</label>
      {value && (
        <img
          src={value}
          alt="preview"
          className="w-24 h-24 object-cover rounded mb-2 border border-white/25"
          data-testid={`${testId}-preview`}
        />
      )}
      <div className="flex gap-2 items-center">
        <input
          type="text"
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          className="flex-1 bg-white/10 border border-white/25 text-white px-4 py-2 rounded"
          placeholder="Paste a URL or upload an image"
          data-testid={`${testId}-url-input`}
        />
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          disabled={uploading}
          className="btn-secondary flex items-center gap-2 whitespace-nowrap"
          data-testid={`${testId}-upload-btn`}
        >
          {uploading ? <Loader2 size={18} className="animate-spin" /> : <Upload size={18} />}
          {uploading ? 'Uploading...' : 'Upload'}
        </button>
        <input
          ref={inputRef}
          type="file"
          accept="image/*"
          onChange={handleFile}
          className="hidden"
          data-testid={`${testId}-file-input`}
        />
      </div>
      {error && (
        <p className="text-red-400 text-xs mt-1" data-testid={`${testId}-error`}>
          {error}
        </p>
      )}
    </div>
  );
};

export default ImageUpload;
